import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './quotationEvaluationsModuleConfig';
import { QuotationEvaluation, useQuotationEvaluations } from './useData';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<QuotationEvaluation> useData={useQuotationEvaluations} config={config} />;
};

export default List;
